
import classNames from 'classnames';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { ReactSortable } from 'react-sortablejs';
import { MoreIcon } from 'tdesign-icons-react';
import { Button, Col, FormInstanceFunctions, Input, MessagePlugin, Row, Select } from 'tdesign-react';
import { v4 } from 'uuid';

import { IStory } from '@/interface';
import { ISubCollection, SubCollectionType } from '@/interface/novel';
import { CollectionSortType } from '@/interface/promotion';
import { fetchStoryList } from '@/services/story';

import CustomNovelSelect from '../customNovelSearch';
import styles from './index.module.less';

const INIT: ISubCollection = {
  name: '未命名',
  desc: '无描述',
  sortType: CollectionSortType.COLLECTIONSORTTYPE_POPULARITY,
  type: SubCollectionType.NOVEL,
  novels: [],
  stories: [],
};

export interface IProps {
  getFieldDecorator: any;
  onChange: (key: any) => void;
  value: (ISubCollection & { id: string })[];
  btnContext: string;
  onBtnClick: (value: string[]) => void;
  valueShow?: string;
  form: FormInstanceFunctions;
  disabled?: boolean;
}
const CustomNovelMultiCollection: React.FC<IProps> = (props) => {
  const {
    onChange,
    value = [],
  } = props;

  const [stories, setStories] = useState<IStory[]>([]);
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  const handleSearch = useCallback((value?: string) => {
    fetchStoryList({ name: value, page: 1, size: 999, release: true }).then((res) => {
      if (res.code !== 0) {
        MessagePlugin.error(res?.message || '服务错误');
      }
      setOptions(res.list.map(item => ({
        value: item.id,
        label: item.name,
      })));
      setStories(pre => _.uniqBy([...pre, ...res.list], 'id'));
    });
  }, []);

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div
      className={classNames('custom-form-group', styles.group)}
      style={{ display: 'block', width: '100%' }}
    >
      {value.length === 0 && <Button
        style={{ float: 'right' }}
        onClick={() => {
          onChange([...value, INIT]);
        }}>
        新增榜单
      </Button>}
      <Row gutter={[16, 16]} className={styles.row} style={{ marginBottom: 8, marginTop: 16 }}>
        <Col span={1}>榜单名</Col>
        <Col span={1}>排序维度</Col>
        <Col span={2}>描述</Col>
        <Col span={1}>类型</Col>
        <Col span={6}>小说/AVG</Col>
      </Row>
      <ReactSortable
        handle='.draggable'
        list={value}
        setList={onChange}
        style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
      >
        {(value || []).map((item, idx) => <Row className={styles.row} align='center' gutter={[16, 16]} key={item.id}>
          <div className={classNames(['draggable', [styles.draggable]])} >
            <MoreIcon />
          </div>
          <Col span={1} className={styles.idx}>
            <Input value={item.name} onChange={(data) => {
              const newValue = value?.map((item, idx2) => ({
                ...item,
                name: idx2 === idx ? data : item.name,
              }));
              onChange(newValue);
            }} />
          </Col>
          <Col span={1} className={styles.idx}>
            <Select
              value={item.sortType as any}
              options={[{ value: CollectionSortType.COLLECTIONSORTTYPE_POPULARITY, label: '人气值' }]}
              onChange={(data) => {
                const newValue = value?.map((item, idx2) => ({
                  ...item,
                  sortType: idx2 === idx ? data as any : item.sortType,
                }));
                onChange(newValue);
              }} />
          </Col>
          <Col span={2} className={styles.idx}>
            <Input value={item.desc} onChange={(data) => {
              const newValue = value?.map((item, idx2) => ({
                ...item,
                desc: idx2 === idx ? data : item.desc,
              }));
              onChange(newValue);
            }} />
          </Col>
          <Col span={1} className={styles.idx}>
            <Select
              value={item.type as any}
              options={[
                { value: SubCollectionType.NOVEL, label: '小说' },
                { value: SubCollectionType.AVG, label: 'AVG' },
              ]}
              onChange={(data) => {
                const newValue = value?.map((item, idx2) => ({
                  ...item,
                  type: idx2 === idx ? data as any : item.type,
                  ...(idx2 === idx && {
                    // 当切换为小说类型时清空AVG内容，反之亦然
                    novels: data === SubCollectionType.AVG ? [] : item.novels,
                    stories: data === SubCollectionType.NOVEL ? [] : item.stories,
                  }),
                }));
                onChange(newValue);
              }} />
          </Col>
          <Col span={6}>
            {item.type === SubCollectionType.AVG
              ? <Select
                filterable
                multiple
                value={item.stories.map(({ id }) => id)}
                options={options}
                onSearch={handleSearch}
                onBlur={() => {
                  setOptions(stories.map(({ id, name }) => ({ value: id, label: name })));
                }}
                onChange={(data: any) => {
                  const newValue = value?.map((item, idx2) => ({
                    ...item,
                    stories: idx2 === idx ? stories.filter(({ id }) => data.includes(id)) : item.stories,
                  }));
                  onChange(newValue);
                }}
              />
              : <CustomNovelSelect
                value={item.novels}
                onChange={(data) => {
                  const newValue = value?.map((item, idx2) => ({
                    ...item,
                    novels: idx2 === idx ? data : item.novels,
                  }));
                  onChange(newValue);
                }}
              />
            }
          </Col>
          <Col span={1}>
            <Button
              className={styles.btn}
              onClick={() => {
                onChange([
                  ...value,
                  { ...INIT, id: v4() },
                ]);
              }}>
              +
            </Button>
            <Button
              disabled={value.length === 1}
              onClick={() => {
                onChange([...value.slice(0, idx), ...value.slice(idx + 1)]);
              }}
              theme='default'
              className={styles.btn}>
              -
            </Button>
          </Col>
        </Row>)}
      </ReactSortable>
    </div >
  );
};

export default CustomNovelMultiCollection;
